import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
// check if loggedin
import store from "./redux/store";
import { BrowserRouter } from "react-router-dom";
import { Loading } from "./components";
import { QueryClient, QueryClientProvider } from "react-query";
import { ReactQueryDevtools } from "react-query/devtools";
import { registerLicense } from '@syncfusion/ej2-base';

const App = React.lazy(() => import("./App"));
// Using valid Syncfusion license key
registerLicense('Ngo9BigBOggjHTQxAR8/V1JHaF5cWWdCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdlWXxfeHVVRGVZV0B3WEBWYEo=');

const client = new QueryClient();
ReactDOM.render(
  <Suspense fallback={<Loading />}>
    <BrowserRouter>
      <Provider store={store}>
        <QueryClientProvider client={client}>
          <App />
          <ReactQueryDevtools />
        </QueryClientProvider>
      </Provider>
    </BrowserRouter>
  </Suspense>,
  document.getElementById("root")
);
